import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { Header, Main } from './styled-components/common';
import ItemDetails from './components/ItemDetails';
import ItemList from './components/ItemList';
import { itemsRaw } from './data';
import { getItemsWithFakePrices } from './helpers';

class App extends React.Component {
  state = { items: getItemsWithFakePrices(itemsRaw) };

  render() {
    const { items } = this.state;

    return (
      <>
        <Header />
        <Main>
          <Switch>
            <Route exact path="/" render={() => <ItemList items={items} />} />
            <Route
              path="/items/:id"
              render={({ match }) => {
                const item =
                  items.find(_item => _item.id === match.params.id) || {};
                const pickedProperties = (({
                  shortName,
                  displayPrice,
                  largestImageUrl,
                }) => ({
                  shortName,
                  displayPrice,
                  imageUrl: largestImageUrl,
                }))(item);
                return <ItemDetails {...pickedProperties} />;
              }}
            />
          </Switch>
        </Main>
      </>
    );
  }
}

export default App;
